module.exports = __webpack_public_path__ + "static/00002.f4c22cf9.jpg";